import React, { useContext } from "react";

import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

import LanguageContext from "../../LanguageContext";
import messages from "../../services/messages";
import firebase from "../../firebase";

import Profit from "./Profit";

const FarmerProfit = ({ classes, userState }) => {
  const language = useContext(LanguageContext);

  return (
    <div className={classes.greySection}>
      <Grid container direction="row" justifyContent="center" alignItems="center">
        <Grid item className={classes.item}>
          <Typography variant={"h5"} style={{ fontWeight: "bold" }}>
            {messages["landing.farmerProfit"][language]}
          </Typography>
        </Grid>
      </Grid>

      <Profit
        classes={classes}
        title={messages["landing.profit1"][language]}
        icon={"/icons/Profit1.svg"}
      />
      <Profit
        classes={classes}
        title={messages["landing.profit2"][language]}
        icon={"/icons/Profit2.svg"}
      />

      <Profit
        classes={classes}
        title={messages["landing.profit3"][language]}
        icon={"/icons/Profit3.svg"}
      />

      <Grid container direction="row" justifyContent="center" alignItems="center">
        <Grid item>
          <Button
            href={"/join"}
            size={"large"}
            color={"primary"}
            variant={"contained"}
            endIcon={<ArrowForwardIcon />}
            onClick={() => {
              let stateName = userState
                ? userState.name_en.toLowerCase()
                : "maharashtra";
              firebase.analytics().logEvent("joingold_clicked", {
                state_name: stateName,
                page: "landing",
                section: "benefits",
              });
            }}
          >
            {messages["landing.tryFree"][language]}
          </Button>
        </Grid>
      </Grid>
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
        className={classes.twentyFiveKCaption}
      >
        <Grid item xs={1}></Grid>
        <Grid item xs={10} md={3}>
          <Typography
            variant={"caption"}
            align={"center"}
            className={classes.join25k}
            component={"div"}
          >
            {messages["landing.join25K"][language]}
          </Typography>
        </Grid>
        <Grid item xs={1}></Grid>
      </Grid>
    </div>
  );
};

export default FarmerProfit;
